import { useState } from "react";
import { ScanBookTab } from "../components/ScanBookTab";
import { ScanAlbumTab } from "../components/ScanAlbumTab";
import { ScanMovieTab } from "../components/ScanMovieTab";

type Tab = "book" | "album" | "movie";

const TABS: { key: Tab; label: string }[] = [
  { key: "book", label: "Book" },
  { key: "album", label: "Vinyl" },
  { key: "movie", label: "Movie" },
];

export function ScanPage() {
  const [tab, setTab] = useState<Tab>("book");

  return (
    <div className="space-y-4">
      <div className="flex gap-2 border-b border-gray-700">
        {TABS.map((t) => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px ${
              tab === t.key
                ? "border-blue-500 text-blue-400"
                : "border-transparent text-gray-400 hover:text-gray-200"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === "book" && <ScanBookTab />}
      {tab === "album" && <ScanAlbumTab />}
      {tab === "movie" && <ScanMovieTab />}
    </div>
  );
}
